import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);
// Containers
const DefaultContainer = () => import("@/containers/DefaultContainer");
const ShopContainer = () => import("@/containers/ShopContainer");

// Shared Pages
const Login = () => import("@/views/Login");
const Page404 = () => import("@/views/Page404");
const ChangeLog = () => import("@/views/ChangeLog");
const CustomerLogin = () => import("@/views/CustomerLogin");
const ChangePassword = () => import("@/views/ChangePassword");
const SellerCommission = () => import("@/views/SellerCommission");
const DeliveryCosts = () => import("@/views/DeliveryCosts");

// HRM
const Employees = () => import("@/views/HRM/Employees");

const Listpublications = () => import("@/views/Publishers/Listpublications");

// SHOP
const ShopReports = () => import("@/views/Shop/Reports");
const ShopReceives = () => import("@/views/Shop/Receives");
const ShopPayments = () => import("@/views/Shop/Payments");
const VisitLogs = () => import("@/views/Shop/VisitLogs");
const ShopProducts = () => import("@/views/Shop/Products");
const VariantsList = () => import("@/views/Shop/VariantsList");
const AddProduct = () => import("@/views/Shop/AddProduct");
const EditProduct = () => import("@/views/Shop/EditProduct");
const ShopCustomer = () => import("@/views/Shop/Customer");
const ShopCustomers = () => import("@/views/Shop/Customers");
const InvoiceDetails = () => import("@/views/Shop/InvoiceDetails");
const PreviewShop = () => import("@/views/Shop/PreviewShop");
const SinglePreviewShop = () => import("@/views/Shop/PreviewShop/Single");
const MultiPreviewShop = () => import("@/views/Shop/PreviewShop/Multi");

// GENERAL
const Dashboard = () => import("@/views/General/Dashboard");
const NewInvoice = () => import("@/views/General/NewInvoice");
const CustomerClub = () => import("@/views/General/CustomerClub");
const SalesInvoices = () => import("@/views/General/SalesInvoices");
const SalesProducts = () => import("@/views/General/SalesProducts");
const VideosManager = () => import("@/views/General/VideosManager");

const Brands = () => import("@/views/General/Brands");
const EditInvoice = () => import("@/views/General/EditInvoice");
// Sales Manager
const SalesManager = () => import("@/views/SalesManager");
const Cheques = () => import("@/views/Cheques");
const Installments = () => import("@/views/Installments");

const Listauthor = () => import("@/views/Authors/Listauthor");
const ReportLists = () => import("@/views/Reports/ReportLists");
// const ProductReport = () => import("@/views/Reports/ProductReport");
const PostReport = () => import("@/views/Reports/PostReport");
const SellReport = () => import("@/views/Reports/SellReport");

// Online Shop
const MainPage = () => import("@/views/OnlineShop/Main");
const AccountInformation = () =>
  import("@/views/OnlineShop/AccountInformation");
const Cart = () => import("@/views/OnlineShop/Cart/Cart");
const Shipping = () => import("@/views/OnlineShop/Shipping");
const ProductDetails = () =>
  import("@/views/OnlineShop/ProductDetails/ProductDetails");
const Author = () => import("@/views/OnlineShop/Author/Author");
const Publisher = () => import("@/views/OnlineShop/Publisher/Publisher");
const PurchaseProcess = () =>
  import("@/views/OnlineShop/PurchaseProcess/PurchaseProcess");
const PurchaseDetails = () => import("@/views/OnlineShop/PurchaseDetails");
const OnlineSales = () => import("@/views/OnlineShop/OnlineSales");
const AdminCategories = () => import("@/views/OnlineShop/AdminCategories");
const Comments = () => import("@/views/OnlineShop/Comments");
const ConsultationRequests = () =>
  import("@/views/OnlineShop/ConsultationRequests");
const Profile = () => import("@/views/OnlineShop/Profile");
const CategoryId = () => import("@/views/OnlineShop/CategoryId");
const ContactUs = () => import("@/views/OnlineShop/ContactUs");
const AboutUs = () => import("@/views/OnlineShop/AboutUs");
const Help = () => import("@/views/OnlineShop/Help");
const Helpbuy = () => import("@/views/OnlineShop/Helpbuy");
const AcademicAdvice = () => import("@/views/OnlineShop/AcademicAdvice");
const Rules = () => import("@/views/OnlineShop/Rules");
const Store = () => import("@/views/OnlineShop/Store");
const StoreChild = () => import("@/views/OnlineShop/StoreChild");
const ShippingMethods = () => import("@/views/OnlineShop/ShippingMethods");
const Banners = () => import("@/views/OnlineShop/Banners");
const SuccessfulPurchase = () =>
  import("@/views/OnlineShop/SuccessfulPurchase");
const UnsuccessfulPurchase = () =>
  import("@/views/OnlineShop/UnsuccessfulPurchase");
const SearchResult = () => import("@/views/OnlineShop/SearchResult");

let router = new Router({
  mode: "history", // https://router.vuejs.org/api/#mode
  linkActiveClass: "open active",
  scrollBehavior: () => ({ x: 0, y: 0 }),
  routes: [
    {
      path: "/manager/dashboard",
      // redirect: "/",
      name: "خانه",
      component: DefaultContainer,
      meta: { requiresAuth: false },
      children: [
        {
          path: "/changelog",
          name: "تغییرات هر نسخه",
          component: ChangeLog,
          meta: { requiresAuth: false },
        },
        {
          path: "/manager/dashboard",
          name: "داشبورد ",
          component: Dashboard,
          meta: { requiresAuth: true },
        },
        {
          path: "/manager/changePassword",
          name: "تغییر رمزعبور مدیر",
          component: ChangePassword,
          meta: { requiresAuth: true },
        },
        {
          path: "/manager/DeliveryCosts",
          name: "هزینه‌ ارسال",
          component: DeliveryCosts,
          meta: { requiresAuth: true },
        },
        {
          path: "/manager/banners",
          name: "مدیریت بنرها ",
          component: Banners,
          meta: { requiresAuth: true },
        },
        {
          path: "/manager/sellerCommission",
          name: "کمیسیون فروشنده‌ها",
          component: SellerCommission,
          meta: { requiresAuth: true },
        },
        {
          path: "/manager/videos",
          name: "مدیریت ویدئو های اموزشی",
          component: VideosManager,
          meta: { requiresAuth: true },
        },
        {
          path: "/manager/customersClub",
          name: "مدیریت| تنظیمات باشگاه مشتریان",
          component: CustomerClub,
          meta: { requiresAuth: true },
        },
        {
          path: "/manager/salesManager",
          name: "مدیریت فروش",
          component: SalesManager,
          meta: { requiresAuth: true },
        },
        {
          path: "/manager/installments",
          name: "مدیریت اقساط",
          component: Installments,
          meta: { requiresAuth: true },
        },
        {
          path: "/manager/author",
          name: "مدیریت نویسندگان",
          component: Listauthor,
          meta: { requiresAuth: true },
        },
        {
          path: "/manager/cheque",
          name: "گزارش چک‌ها",
          component: Cheques,
          meta: { requiresAuth: true },
        },
        {
          path: "/sales/changePassword",
          name: "تغییر رمزعبور فروشنده",
          component: ChangePassword,
          meta: { requiresAuth: true },
        },
        {
          path: "/sales/newInvoice",
          name: "مدیریت|  فاکتور جدید",
          component: NewInvoice,
          meta: { requiresAuth: true },
        },
        {
          path: "/sales/salesInvoices",
          name: "مشاهده فاکتورهای فروش",
          component: SalesInvoices,
          meta: { requiresAuth: true },
        },
        {
          path: "/sales/salesProducts",
          name: "محصولات",
          component: SalesProducts,
          meta: { requiresAuth: true },
        },

        // HRM

        {
          path: "/hrm/employees",
          name: "مدیریت پرسنل",
          component: Employees,
          meta: { requiresAuth: true },
        },

        // SHOP
        {
          path: "/shop/dashboard",
          name: "داشبورد فروشگاه",
          component: Dashboard,
          meta: { requiresAuth: false },
        },
        {
          path: "/shop/products",
          name: "محصولات فروشگاه",
          component: ShopProducts,
          meta: { requiresAuth: false },
        },
        {
          path: "/shop/variantslist",
          name: " لیست تنوع‌ها",
          component: VariantsList,

          meta: { requiresAuth: false },
        },
        {
          path: "/shop/addProduct",
          name: " افزودن محصول",
          component: AddProduct,
          meta: { requiresAuth: true },
        },
        {
          path: "/shop/editproduct/:id",
          name: " ویرایش محصول",
          component: EditProduct,
          meta: { requiresAuth: true },
        },
        {
          path: "/manager/publishers",
          name: "لیست انتشارات",
          component: Listpublications,
          meta: { requiresAuth: true },
        },
        {
          path: "/shop/customers",
          name: "مشتریان",
          component: ShopCustomers,
          meta: { requiresAuth: true },
        },
        {
          path: "/shop/customer/:id",
          name: "پروفایل مشتری",
          component: ShopCustomer,
          meta: { requiresAuth: true },
        },
        {
          path: "/shop/salesInvoices",
          name: "مدیریت| مشاهده فاکتورهای فروش",
          component: SalesInvoices,
          meta: { requiresAuth: true },
        },
        {
          path: "/shop/newInvoice",
          name: "فاکتور جدید",
          component: NewInvoice,
          meta: { requiresAuth: true },
        },
        {
          path: "/shop/invoice/:id",
          name: "مشاهده فاکتور",
          component: InvoiceDetails,
          meta: { requiresAuth: true },
        },

        {
          path: "/shop/reports",
          name: "گزارش‌ها",
          component: ShopReports,
          meta: { requiresAuth: true },
        },
        {
          path: "/shop/receives",
          name: "دریافتی‌ها",
          component: ShopReceives,
          meta: { requiresAuth: true },
        },
        {
          path: "/shop/payments",
          name: "پرداختی‌ها",
          component: ShopPayments,
          meta: { requiresAuth: true },
        },
        {
          path: "/shop/visitLogs",
          name: "آمار بازدیدها",
          component: VisitLogs,
          meta: { requiresAuth: true },
        },

        {
          path: "/shop/customersClub",
          name: "تنظیمات باشگاه مشتریان",
          component: CustomerClub,
          meta: { requiresAuth: true },
        },
        {
          path: "/shop/changePassword",
          name: "تغییر رمزعبور مسئول فروشگاه",
          component: ChangePassword,
          meta: { requiresAuth: true },
        },
        //onlineShop-admin
        {
          path: "/manager/onlinesales",
          name: "فروش آنلاین   ",
          component: OnlineSales,
          meta: { requiresAuth: true },
        },
        {
          path: "/manager/brands",
          name: "برند‌ها",
          component: Brands,
          meta: { requiresAuth: true },
        },
        {
          path: "/shop/editinvoice/:id",
          name: "ویرایش سفارش",
          component: EditInvoice,
          meta: { requiresAuth: true },
        },
        {
          path: "/manager/admincategories",
          name: " دسته‌بندی‌ها   ",
          component: AdminCategories,
          meta: { requiresAuth: true },
        },
        {
          path: "/manager/comments",
          name: " نظرات  ",
          component: Comments,
          meta: { requiresAuth: true },
        },
        {
          path: "/manager/consultationrequests",
          name: "درخواست‌های مشاوره",
          component: ConsultationRequests,
        },
        {
          path: "/manager/ReportLists",
          name: "مدیریت گزارش‌ها",
          component: ReportLists,
          meta: { requiresAuth: true },
        },
        // {
        //   path: "/manager/ProductReport",
        //   name: "گزارش فروش یک محصول",
        //   component: ProductReport,
        //   meta: { requiresAuth: true },
        // },
        {
          path: "/manager/PostReport",
          name: "گزارش عملکرد ارسال سفارش‌ها(پست)",
          component: PostReport,
          meta: { requiresAuth: true },
        },
        {
          path: "/manager/sellReport",
          name: "گزارش عملکرد فروش",
          component: SellReport,
          meta: { requiresAuth: true },
        },
      ],
    },

    // Online Shop
    { path: "/main", redirect: "/" },
    { path: "/sign", redirect: "/" },
    { path: "/shop", redirect: "/store/all" },
    { path: "/author", redirect: "/store/all" },
    { path: "/publisher", redirect: "/store/all" },
    { path: "/customerLogin", redirect: "/" },
    { path: "/product-category", redirect: "/" },
    { path: "/product-category/:name", redirect: "/" },
    { path: "/نویسنده", redirect: "/" },
    { path: "/نویسنده/:name", redirect: "/" },
    {
      path: "*", // Catch-all route for undefined paths
      redirect: "/", // Redirect to homepage
    },
    { path: "/productDetails", redirect: "/store/all" },
    {
      path: "/productDetails/:id/:name",
      redirect: "/productDetails/:name-:id",
    },
    { path: "/product", redirect: "/store/all" },
    { path: "/store", redirect: "/store/all" },
    // { path: "/product/:id", redirect: "/productDetails/:name-:id" },
    { path: "/product/:id/:name", redirect: "/productDetails/:name-:id" },
    { path: "/products", redirect: "/store/all" },
    {
      path: "/",
      name: "صفحه خانه",
      meta: { requiresAuth: false },
      component: ShopContainer,
      children: [
        {
          path: "/",
          name: "صفحه اصلی",
          component: MainPage,
          meta: { header: true, footer: true, requiresAuth: false },
        },
        {
          path: "/result",
          name: "صفحه جستجو",
          component: SearchResult,
          meta: { header: true, footer: true, requiresAuth: false },
        },
        {
          path: "/productDetails/:name-:id",
          name: "مشخصات محصول",
          component: ProductDetails,
          meta: { header: true, footer: true, requiresAuth: false },
        },
        {
          path: "/author/:name-:id",
          name: "درباره نویسنده",
          component: Author,
          meta: { header: true, footer: true, requiresAuth: false },
        },
        {
          path: "/publisher/:name-:id",
          name: "درباره انتشارات",
          component: Publisher,
          meta: { header: true, footer: true, requiresAuth: false },
        },
        // {
        //   path: "/productDetails/:id/:name",
        //   name: "مشخصات محصول",
        //   component: ProductDetails,
        //   meta: { header: true, footer: true, requiresAuth: false },
        // },
        {
          path: "/PurchaseDetails/:id",
          name: "جزییات خرید",
          component: PurchaseDetails,
          meta: { header: true, footer: true, requiresAuth: true },
        },
        {
          path: "/checkout/cart",
          name: "سبد خرید ",
          component: Cart,
          meta: { header: true, footer: true, requiresAuth: true },
        },
        {
          path: "/accountinformation",
          name: "اطلاعات حساب کاربری",
          component: AccountInformation,
          meta: { header: false, footer: false, requiresAuth: true },
        },
        {
          path: "/storeChild",
          name: "StoreChild",
          component: StoreChild,
          props: (route) => ({ query: route.query }),
          meta: { header: true, footer: true, requiresAuth: false },
        },
        {
          path: "/store/:query",
          name: " فروشگاه",
          component: Store,
          meta: { header: true, footer: true, requiresAuth: false },
        },

        // {
        //   path: "/checkout/shipping",
        //   name: " ارسال",
        //   component: Shipping,

        //   meta: { requiresAuth: true },
        // },
        {
          path: "/purchase-process",
          name: "اطلاعات و ارسال",
          component: PurchaseProcess,
          meta: { header: true, footer: true, requiresAuth: true },
        },
        {
          path: "/profile",
          name: "پروفایل کاربر",
          component: Profile,
          meta: { header: true, footer: true, requiresAuth: true },
        },
        // {
        //   path: "/categories",
        //   name: "دسته‌بندی‌ محصولات",
        //   component: Categories,
        //   meta: { requiresAuth: false },
        // },
        // {
        //   path: "/category/:id",
        //   name: "جزئیات دسته‌بندی‌",
        //   component: CategoryId,
        //   meta: { requiresAuth: false },
        // },
        {
          path: "/contactUs",
          name: "تماس با ما",
          component: ContactUs,
          meta: { header: true, footer: true, requiresAuth: false },
        },
        {
          path: "/aboutus",
          name: "درباره ما",
          component: AboutUs,
          meta: { header: true, footer: true, requiresAuth: false },
        },
        {
          path: "/help",
          name: "راهنما",
          component: Help,
          meta: { header: true, footer: true, requiresAuth: false },
        },
        {
          path: "/academicAdvice",
          name: "مشاوره تحصیلی",
          component: AcademicAdvice,
          meta: { header: true, footer: true, requiresAuth: false },
        },
        {
          path: "/helpbuy",
          name: " راهنمای خرید",
          component: Helpbuy,
          meta: { header: true, footer: true, requiresAuth: false },
        },
        {
          path: "/rules",
          name: " قوانین . مقررات",
          component: Rules,
          meta: { header: true, footer: true, requiresAuth: false },
        },
        // {
        //   path: "/shippingmethods",
        //   name: " نحوه ارسال سفارشات",
        //   component: ShippingMethods,
        //   meta: { requiresAuth: true },
        // },
        {
          path: "/successfulPurchase",
          name: "پرداخت موفقیت آمیز",
          component: SuccessfulPurchase,
          meta: { header: true, footer: true, requiresAuth: true },
        },
        {
          path: "/unsuccessfulPurchase",
          name: "پرداخت ناموفق",
          component: UnsuccessfulPurchase,
          meta: { header: true, footer: true, requiresAuth: true },
        },
      ],
    },

    { path: "*", component: Page404 },
    {
      path: "/login",
      name: "Login",
      component: Login,
      meta: { requiresAuth: false },
    },
    // {
    //   path: "/customerLogin",
    //   name: "CustomerLogin",
    //   component: CustomerLogin,
    //   meta: { requiresAuth: false },
    // },
    {
      path: "/printPreview",
      name: "",
      component: PreviewShop,
      meta: { requiresAuth: true },
    },
    {
      path: "/printPreview/single/:id",
      name: "SinglePreviewShop",
      component: SinglePreviewShop,
      meta: { requiresAuth: true },
    },
    {
      path: "/printPreview/multi/:ids",
      name: "MultiPreviewShop",
      component: MultiPreviewShop,
      meta: { requiresAuth: true },
    },
  ],
});
router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0);
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (
      localStorage.getItem("token") == null &&
      localStorage.getItem("shopToken") == null
    ) {
      localStorage.setItem("requiresAuth", "true");
      localStorage.setItem("preLoginRoute", to.fullPath);
      next({
        path: "/",
      });
    } else {
      next();
    }
  } else if (to.matched.some((record) => record.meta.guest)) {
    if (
      localStorage.getItem("token") == null &&
      localStorage.getItem("shopToken") == null
    ) {
      next();
    } else {
      next();
    }
  } else {
    next();
  }
});
export default router;
